import {connect} from "react-redux";
import AttendanceRequestApproval from "./Approval";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {attendanceRequest} from "../../../service/AttendanceReqularization/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    makeAttendanceRequest:state.AttendanceRegularization.makeAttendanceRequest,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            attendanceRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceRequestApproval);
